import { RuleAudienceIcon } from '@/lib';
import { FC, SVGProps } from 'react';
import { LuCalendar } from 'react-icons/lu';
import { twMerge } from 'tailwind-merge';

type IconProps = { className?: string };

export const AudienceFilterIcon: FC<IconProps> = ({ className }) => <RuleAudienceIcon className={twMerge('size-4 text-primary-600', className)} aria-hidden />;

export const CalendarFilterIcon: FC<IconProps> = ({ className }) => <LuCalendar className={twMerge('size-4 text-primary-600', className)} aria-hidden />;

export const GoogleAdsIcon: FC<IconProps> = ({ className }) => (
  <img className={twMerge('grid size-5 shrink-0 place-items-center', className)} aria-hidden src='/icons/google-png.png' alt='Google' />
);

export const MetaIcon: FC<IconProps> = ({ className }) => (
  <img className={twMerge('grid size-5 shrink-0 place-items-center', className)} aria-hidden src='/icons/facebook-meta-png.png' alt='FB Meta' />
);

export const BarChartHeaderIcon: FC<SVGProps<SVGSVGElement>> = ({ className, ...props }) => (
  <svg viewBox='0 0 20 20' fill='none' className={twMerge('size-5 text-brand-600', className)} aria-hidden {...props}>
    <path d='M3 16V8M8 16V4M13 16V10M18 16V6' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
  </svg>
);
